import api from "@/services/api.service";
import { ActionContext, ActionTree } from "vuex";
import { RootState } from "../types";
import { AreaEventHistoryState } from "./types";

export const actions: ActionTree<AreaEventHistoryState, RootState> = {
	async fetchAreaEventHistory({ commit, state }: ActionContext<AreaEventHistoryState, RootState>): Promise<void> {
		try {
			const areaEventHistory = await api.fetchAreaEventHistory(state.filter);

			if (!areaEventHistory) {
				commit("setAreaEventHistory", []);
				commit("setTotalRecords", 0);
				return;
			}

			commit("setAreaEventHistory", areaEventHistory.data);
			commit("setTotalRecords", areaEventHistory.totalRecords);
		} catch (error) {
			commit("setAreaEventHistory", []);
			commit("setTotalRecords", 0);
			console.error("Error fetching area event history:", error);
		}
	},
};
